// Center heading processor module
// Converts {{center}} marker in headings to centered text alignment
// Usage: <h2>{{center}}My Centered Heading</h2> or <h2>My {{center}}Centered{{/center}} Heading</h2>

export function initCenterHeading() {
  // Only initialize on post/page templates
  const isPostPage = document.body.classList.contains('post-template') || 
                    document.body.classList.contains('page-template') ||
                    document.querySelector('.gh-content');
  
  if (!isPostPage) return;

  const contentElement = document.querySelector('.gh-content');
  if (!contentElement) return;

  const centerRegex = /\{\{center\}\}/g;
  const centerWithCloseRegex = /\{\{center\}\}([\s\S]*?)\{\{\/center\}\}/g;

  function applyCenter(el, className) {
    const html = el.innerHTML || '';
    let hasCenterMarker = false;
    let updatedHTML = html;

    if (centerWithCloseRegex.test(html)) {
      updatedHTML = html.replace(centerWithCloseRegex, '$1');
      hasCenterMarker = true;
    }

    centerRegex.lastIndex = 0;
    if (centerRegex.test(updatedHTML)) {
      updatedHTML = updatedHTML.replace(/\{\{center\}\}/g, '');
      hasCenterMarker = true;
    }

    if (hasCenterMarker) {
      el.classList.add(className);
      el.innerHTML = updatedHTML.trim().replace(/\s+/g, ' ');
    }
  }

  // Headings
  contentElement.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(el => {
    applyCenter(el, 'heading-center');
  });

  // Callout cards
  contentElement.querySelectorAll('.kg-callout-text').forEach(el => {
    applyCenter(el, 'heading-center');
  });

  // Paragraphs — inline {{center}}...{{/center}} wraps only the matched part
  contentElement.querySelectorAll('p').forEach(el => {
    const html = el.innerHTML || '';
    if (!html.includes('{{center}}')) return;

    // Check if marker covers the entire paragraph content
    const fullRegex = /^\s*\{\{center\}\}([\s\S]*?)\{\{\/center\}\}\s*$/;
    const fullMatch = html.match(fullRegex);
    if (fullMatch) {
      el.classList.add('heading-center');
      el.innerHTML = fullMatch[1].trim();
      return;
    }

    // Standalone {{center}} at start/alone — center whole paragraph
    const standaloneRegex = /^\s*\{\{center\}\}\s*$/;
    if (standaloneRegex.test(html)) {
      el.classList.add('heading-center');
      el.innerHTML = '';
      return;
    }

    // Partial — replace each {{center}}...{{/center}} with a centered block span
    const partialRegex = /\{\{center\}\}([\s\S]*?)\{\{\/center\}\}/g;
    if (partialRegex.test(html)) {
      el.innerHTML = html.replace(
        /\{\{center\}\}([\s\S]*?)\{\{\/center\}\}/g,
        '<span style="display:block;text-align:center">$1</span>'
      );
    }
  });
}

